// extracted by mini-css-extract-plugin
export default {"sliderShell":"SliderComp_sliderShell__r-aom","viewport":"SliderComp_viewport__FT+eH","track":"SliderComp_track__Ao1c2","card":"SliderComp_card__wkjoo"};